import React, { useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { Box, ButtonBase, FormControlLabel, TextField, Typography } from '@material-ui/core';
import { CustomButton, CustomCheckbox } from '../button';
import tokens from '../theme/tokens';

// 이메일 로그인 폼 — 아이디(e-mail)·비밀번호·아이디 저장·찾기 링크·[로그인]. 개인/기업 탭 모두 같은 폼을 쓴다
const useStyles = makeStyles(() => ({
  root: { width: '100%' },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 8,
    marginBottom: 22,
  },
  save: {
    marginLeft: -6,
    '& .MuiTypography-root': { fontSize: 14, color: tokens.text, letterSpacing: -0.4 },
  },
  links: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 14,
    color: tokens.muted,
    '& span': { margin: '0 8px', color: tokens.line },
  },
  link: {
    fontSize: 14,
    letterSpacing: -0.4,
    color: tokens.text,
    '&:hover': { color: tokens.primaryDark },
  },
  submit: { height: 52, fontSize: 17 },
}));

function EmailLoginForm({ initialEmail = '', onSubmit, onFindId, onFindPwd, submitLabel = '로그인' }) {
  const cs = useStyles();
  const [email, setEmail] = useState(initialEmail);
  const [password, setPassword] = useState('');
  const [saveId, setSaveId] = useState(Boolean(initialEmail));

  const submit = (e) => {
    if (e) e.preventDefault();
    onSubmit({ email: email.trim(), password, saveId });
  };

  return (
    <form className={cs.root} onSubmit={submit}>
      <Box className="mainFormGroup">
        <TextField
          name="email"
          placeholder="아이디(e-mail)"
          variant="outlined"
          fullWidth
          className={clsx('formArea')}
          value={email}
          autoComplete="username"
          inputProps={{ inputMode: 'email' }}
          onChange={(e) => setEmail(e.target.value)}
        />
        <TextField
          name="password"
          type="password"
          placeholder="비밀번호"
          variant="outlined"
          fullWidth
          className={clsx('formArea')}
          value={password}
          autoComplete="current-password"
          onChange={(e) => setPassword(e.target.value)}
        />
      </Box>
      <div className={cs.row}>
        <FormControlLabel
          className={cs.save}
          control={<CustomCheckbox name="saveId" checked={saveId} onChange={(e, checked) => setSaveId(checked)} />}
          label={<Typography>아이디 저장</Typography>}
        />
        <div className={cs.links}>
          <ButtonBase className={cs.link} onClick={onFindId} focusRipple={false}>아이디 찾기</ButtonBase>
          <span>|</span>
          <ButtonBase className={cs.link} onClick={onFindPwd} focusRipple={false}>비밀번호 찾기</ButtonBase>
        </div>
      </div>
      <CustomButton type="submit" className={cs.submit} fullWidth variant="contained" color="primary">{submitLabel}</CustomButton>
    </form>
  );
}

export default EmailLoginForm;
